export const NOTIFICATION_INFO_SET_COUNT_INFO =
  "NOTIFICATION_INFO_SET_COUNT_INFO";
export const NOTIFICATION_INFO_LOWER_COUNT_INFO =
  "NOTIFICATION_INFO_REMOVE_COUNT_INFO";
